// Type,Name,Client Id,Id,Parent Id,Brand Id
// Format Version,6,,,,
// Brand List,<brand list name>,0-0-0,-1,,,,
// Brand Item,,0-0-0-0-0,,-1,<brandid1>

export const BrandItem = {
  parent: 'BrandList',
  properties: {
    'bulk-upload-type': {
      type: 'string',
      value: 'Brand Item',
    },
    Status: {
      'bulk-upload-header': 'Status',
    },
    Id: {
      'bulk-upload-header': 'Brand Id',
    },
    ParentId: {
      'bulk-upload-header': 'Parent ID',
    },
    ClientId: {
      'bulk-upload-header': 'Client Id',
    },
  },
};
